import SceneObjectData from "./SceneObjectData";
import apiSceneObjectDataSchema from "../../services/bimVisualizerApi/schema/document/sceneObject/apiSceneObjectDataSchema";
import SceneObjectTypeEnum from "./SceneObjectTypeEnum";
import TextAnnotationData from "./TextAnnotationData";
import LengthDimensionData from "./LengthDimensionData";
import ChecklistItemData from "./ChecklistItemData";
import AreaAnnotationData from "./AreaAnnotationData";
import RectangleAnnotationData from "./RectangleAnnotationData";
import CircleAnnotationData from "./CircleAnnotationData";
import createSceneObjectTypeData from "./SceneObjectTypeDataFactory";

const createSceneObjectData = (data : any) : SceneObjectData => {

    const parsedData = apiSceneObjectDataSchema.parse(data);
    
    const dataObject = JSON.parse(parsedData.data);

    let sceneObjectData : SceneObjectData;

    switch (parsedData.type) {
        case SceneObjectTypeEnum.TextAnnotation:
            sceneObjectData = TextAnnotationData.fromJson(dataObject);
            break;
        case SceneObjectTypeEnum.LengthDimension:
             sceneObjectData = LengthDimensionData.fromJson(dataObject);
             break;
        case SceneObjectTypeEnum.ChecklistItem:
            sceneObjectData = ChecklistItemData.fromJson(dataObject);
            break;
        case SceneObjectTypeEnum.AreaAnnotation:
            sceneObjectData = AreaAnnotationData.fromJson(dataObject);
            break;
        case SceneObjectTypeEnum.RectangleAnnotation:
            sceneObjectData = RectangleAnnotationData.fromJson(dataObject);
            break;
        case SceneObjectTypeEnum.CircleAnnotation:
            sceneObjectData = CircleAnnotationData.fromJson(dataObject);
            break;
        default:
            throw new Error(`Unknown scene object type: ${parsedData.type}`);
        }

    sceneObjectData.ownedBy = parsedData.ownedBy ?? undefined;
    sceneObjectData.modifiedAt = new Date(parsedData.modifiedAt);
    sceneObjectData.sceneObjectTypeData = createSceneObjectTypeData(parsedData.sceneObjectTypeData ?? null);
    return sceneObjectData;
};

export default createSceneObjectData;